export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14222.55345b25.jpg";